import Main from '../total-look/main';

export default class PromoLanding {
    constructor(node) {
        this.node = node;
        this.loadMoreNode = node.querySelector('[data-load-more]');
        this.fasceWrapperNode = node.querySelector('.fasce-wrapper');

        this.pageNumber = 1;
        this.pageSize = this.loadMoreNode.dataset.pageSize;
        this.coId = this.loadMoreNode.dataset.coId;

        this.addListeners();
    }

    static init() {
        let PromoLandingNode = document.querySelector("[data-promo-landing]");

        if (PromoLandingNode) {
            return new PromoLanding(PromoLandingNode);
        }
    }

    addListeners() {
        let _this = this;

        this.loadMoreNode.addEventListener('click', function(event) {
            event.preventDefault();
            
            _this.updateListing();
            _this.pageNumber++;
        });
    }
    
    updateListing() {
        let _this = this;
        let responseData = {};

        let submittedData = {
            coId: this.coId,
            pageSize: this.pageSize,
            pageNumber: this.pageNumber
        };
        
        this.loadMoreNode.classList.add('busy');

        $.ajax({
            type: "POST",
            url: "/WS/wsPromoLanding.asmx/GetFasce",
            cache: false,
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(submittedData),
            dataType: "json",
            success: function (data) {
                
                $(data.d.HTML).appendTo(_this.fasceWrapperNode);

                if (_this.pageNumber * _this.pageSize >= data.d.Props.totalResults) {
                    _this.loadMoreNode.style.display = "none";
                }
                else {
                    _this.loadMoreNode.style.display = "block";
                }
            },
            error: function (data) {
                responseData = data;
            },
            complete: function() {
                _this.loadMoreNode.classList.remove('busy');
                _this.initScripts();
                
            }
        });        
    }
  
    initScripts() {
        slideHeroHp();
        carouselSlider();
        swiperMosaic();
        if (!document.querySelector('[total-look]')) {
            return;
        }
        const totallook = new Main;
    }
}